import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

export const useClassroomRosterSyncGetList = (options) => {
  return useRestQuery(`${MONOLITH_ORIGIN}/api/v2/roster-sync/`, options);
};

export default useClassroomRosterSyncGetList;
